import { render, staticRenderFns } from "./ChecklistItem.vue?vue&type=template&id=5159f6c0&lang=pug&"
import script from "./ChecklistItem.vue?vue&type=script&lang=ts&"
export * from "./ChecklistItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports